import React, { useEffect, useState } from 'react'
import ListaFichajes from './ListaFichajes'
import { useAuth } from 'context/AuthProvider';
import { apiFichajesService } from 'services/apiFichajesService';
import FiltroFichaje from './FiltroFichaje';
import { Col } from 'reactstrap';

const ListaFichajesEmpleadoImpl = () => {

  //empleado
  const { empleado } = useAuth();
  const today = new Date().toISOString().split('T')[0];
  const [fechaDesde, setFechaDesde] = useState(today);
  const [fechaHasta, setFechaHasta] = useState(today);

  const [fichajes, setFichajes] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [estadoVista, setEstadoVista] = useState("ACTIVOS");

  useEffect(() => {
    setCurrentPage(0);
  }, [fechaDesde, fechaHasta, estadoVista]);

  useEffect(() => {
      const fetchData = async () => {
          if(fechaDesde && fechaHasta){
              try {
                  const response = await apiFichajesService.getFichajesEmpleadByEmpleadoIdAndDatePageable(
                    empleado.empresaId,
                    empleado.id,
                    fechaDesde,
                    fechaHasta,
                    estadoVista,
                    currentPage,
                    10
                  );
                  setFichajes(response?.content || []);
                  setTotalPage(response?.totalPages || 0);
              } catch (err){
                  console.error('Error loading fichajes:', err);
                  setFichajes([]);
                  setTotalPage(0);
              }
          }
      }
      fetchData();
  }, [fechaDesde, fechaHasta, empleado.empresaId, empleado.id, currentPage, estadoVista])

  const getTitle = () => {
    if (estadoVista === "ELIMINADOS") {
      return "Fichajes eliminados";
    }
    if (estadoVista === "TODOS") {
      return "Todos los fichajes";
    }
    return "Fichajes activos";
  };

  return (
    <>
      <FiltroFichaje
        fechaDesde={fechaDesde}
        setFechaDesde={setFechaDesde}
        fechaHasta={fechaHasta}
        setFechaHasta={setFechaHasta}
        estadoVista={estadoVista}
        setEstadoVista={setEstadoVista}
      ></FiltroFichaje>
      {fichajes.length>0 ? (
        <ListaFichajes
          title={getTitle()}
          fichajes={fichajes}
          administrar={false}
          showTraceability={estadoVista !== "ACTIVOS"}
          currentPage={currentPage}
          totalPage={totalPage}
          setCurrentPage={setCurrentPage}
        ></ListaFichajes>
      ) : <Col>Sin fichajes...</Col>}
      
    </>
  )
}

export default ListaFichajesEmpleadoImpl
